import React from 'react'

import { Container, Row, Col, Image, SVGIcon } from 'components/qstrap'
import Typography from 'components/atoms/Typography'

import { string } from 'prop-types'

const ContactItem = ({
  href,
  text,
  type,
}) => (
  <div className="kit-more-info__contact-item">
    <Image src={`/assets/img/kit-landing/icons/${type}.svg`} alt={type}/>
    <Typography component="a" variant="body" href={href} target="_blank" rel="noopener norefferer">
      { text }
    </Typography>
  </div>
)

ContactItem.propTypes = {
  href: string,
  text: string,
  type: string,
}

const MoreInfo = () => (
  <div id="kit-more-info" className="kit-more-info">
    <Container>
      <Row>
        <Col md="6">
          <Typography component="h2" variant="title" className="kit-more-info__title">
            Informasi Lainnya
          </Typography>
          <div className="kit-more-info__contacts">
            <ContactItem
              text="www.kit.edu.kh"
              href="https://www.kit.edu.kh"
              type="website"
            />
            <ContactItem
              text="kitinfo@kit.edu.kh"
              href="mailto:kitinfo@kit.edu.kh"
              type="mail"
            />
            <ContactItem
              text="+855-87-940-937"
              href="tel:+855-87-940-937"
              type="phone"
            />
            <ContactItem
              text="@kirirom.university"
              href="https://instagram.com/kirirom.university"
              type="instagram"
            />
            <ContactItem
              text="KITinstitute"
              href="https://www.facebook.com/KITinstitute/"
              type="facebook"
            />
          </div>
        </Col>
        <Col md="6">
          <Image
            src="/assets/img/kit-landing/brochure/brosur-kit-cambodia-quipper-campus.jpg"
            alt="Brosur KIT Cambodia | Quipper Campus"
            className="img-responsive"
          />
          <div className="text-center">
            <a href="https://campus.quipper.com/media/W1siZiIsIjIwMTkvMDEvMDYvMDIvMzgvMTgvZjc2YmUwYTEtN2VmOC00ZTkzLTljZDUtNWE4NjhjYzc0OWQxLyJdXQ.pdf?filename=Kirirom+Institute+of+Technology+%28KIT+Cambodia%29.pdf&sha=99bb584adae59ad4" className="btn btn-md btn-primary btn-campus" rel="nofollow">
              <SVGIcon name="title-download" size="sm" className="m-t-xs" />
              Unduh Brosur
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
)

export default MoreInfo
